module.exports = __webpack_public_path__ + "static/img/2020-1.f41b3ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/looking-ahead/2020-1.jpg
// module id = dtXG
// module chunks = 0